export default __webpack_public_path__ + "static/media/chatIcon.e2bdaf2c.svg";